import React, {useEffect, useState} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import classes from '../Services.module.scss'
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import WhiteEmojiCard from "../../../components/white-emoji-card/WhiteEmojiCard.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Link} from "react-scroll";
import arrowIcon from '../../../media/icons/arrow-right-plain.svg'
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import Industries from "../../../components/industries/Industries.tsx";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.05,
    slidesToScroll: 1,
};

const ErpSoftwareDev = () => {
    const { t } = useTranslation();

    const [openedBlock] = useState(null);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const title = t('erpSoftwareDevelopment.title');
    const description = t('erpSoftwareDevelopment.description', {returnObjects: true});
    const buttonText = t('erpSoftwareDevelopment.buttonText');

    const blackBlocks = t('erpSoftwareDevelopment.blackBlocks', {returnObjects: true});

    const emojiBlocks = t('erpSoftwareDevelopment.emojiBlocks', {returnObjects: true})

    const servicesBlocks = t('erpSoftwareDevelopment.servicesBlocks', {returnObjects: true})
    const dropDownBlocks = t('erpSoftwareDevelopment.processBlocks', {returnObjects: true})


    const modules = t('erpSoftwareDevelopment.weBuildModules', {returnObjects: true})

    

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
            left: t('erpSoftwareDevelopment.Faq.left', {returnObjects: true}),
            right: t('erpSoftwareDevelopment.Faq.right', {returnObjects: true}),
    };





    return (
        <>
            <Helmet>
                <title>
                    ERP Software Development | Custom ERP Systems Development – Goteco
                </title>
                <meta
                    name="description"
                    content="Custom ERP software development services: consulting, design, integration, support. Scalable ERP solutions for your industry. Get a free consultation!"
                />
                <link rel="canonical" href="https://go-te.co/services/erp-software-development-services" />
            </Helmet>
            <main>
            <Heading title={title} description={description} buttonText={buttonText}/>
            <section className={`${classes['blocks-right']} section--light-gray`}>
                <h2>{t('erpSoftwareDevelopment.blackBlocksTitle')}</h2>
                <div className={classes['blocks-container']}>
                    {blackBlocks.map(({icon, text}) => <BlackCardWithIcon key={icon} iconName={icon} text={text}/>)}
                </div>
            </section>
            <section className={`${classes['text-with-emoji-cards']} section--white`}>
                <div>
                    <h2>{t('erpSoftwareDevelopment.whatIsIt')}</h2>
                    <div>
                        <p>{t('erpSoftwareDevelopment.whatIsItText')}</p>
                        <strong>{t('erpSoftwareDevelopment.whatIsItText2')}</strong>
                    </div>
                </div>
                <div>
                    <div className={classes['blocks-container']}>
                        {emojiBlocks.map(({icon, text}) => <WhiteEmojiCard key={icon} icon={icon} text={text}/>)}
                    </div>
                    <div className={classes['blue-block']}>{t('erpSoftwareDevelopment.whatIsItBottom')}
                    </div>
                </div>
            </section>


            <section className={`${classes['services-container']} section--dark-gray`}>
                <h2>{t('erpSoftwareDevelopment.ourItCons')}</h2>
                <span>{t('erpSoftwareDevelopment.ourItConsText')}</span>
                <div className={classes['blocks-container']}>
                    {servicesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                   text={text} key={title}/>)}
                </div>
                <Slider {...settings} className={classes.slider}>
                    {servicesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                   text={text} key={title}/>)}
                </Slider>
            </section>

            <section className={`${classes['modules-container']} section--white`}>
                <div>
                    <h2>{t('erpSoftwareDevelopment.weBuild')}</h2>
                    <p>{t('erpSoftwareDevelopment.weBuildText')}</p>
                </div>
                <div className={classes.blocks}>
                    {modules.map((text) => <div key={text} className={classes.module}>{text}</div>)}
                </div>
            </section>

            <section className={'section--dark-gray'}>
                <div className={classes["container"]}>
                    <div className={classes["left"]}>
                        <h2 className={classes["header"]}>{t('erpSoftwareDevelopment.process')}</h2>
                        <p className={classes["text"]}>{t('erpSoftwareDevelopment.processText')}</p>
                        <Link className={classes.button} smooth={true} to="contact">
                            <span>{buttonText}</span><img alt="" src={arrowIcon}/>
                        </Link>
                    </div>

                    <div className={classes["right"]}>
                        <div className={classes["drop-down"]}>
                            {dropDownBlocks.map((block, index) => (
                                <div
                                    key={index}
                                    id={index.toString()}
                                    className={classes["drop-down__block"]}
                                >
                                    <div
                                        className={classes["top"]}
                                    >
                                        <div className={classes["drop-down__block__title"]}>
                                            {block.title}
                                        </div>
                                    </div>

                                    <div
                                        className={`${classes["drop-down__content"]} ${
                                            openedBlock === index ? classes["visible"] : classes["hidden"]
                                        }`}
                                    >
                                        {block.content.map((text) => (
                                            <p key={text}>{text}</p>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/*TODO ADD MORE INDUSTRIES*/}
            <section className={`section--white ${classes.industries}`}>
                <div>
                    <h2>{t('erpSoftwareDevelopment.industriesWeServe')}</h2>
                    <p>{t('erpSoftwareDevelopment.industriesWeServeText')}</p>
                </div>
                <div>
                    <Industries/>
                </div>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('erpSoftwareDevelopment.Faq.title')} questions={questions}/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard title={t('erpSoftwareDevelopment.formCard.title')} 
                subtitle={t('erpSoftwareDevelopment.formCard.subtitle')} 
                message={t('erpSoftwareDevelopment.formCard.message')}
                buttonText={t('erpSoftwareDevelopment.formCard.buttonText')} 
                labels={t('erpSoftwareDevelopment.formCard.labels')} 
                top={3}
                id='contact'/>
            </section>
        </main>
        </>
    );
};

export default ErpSoftwareDev;